<span id="first-focus-element"></span>
<rcl-header id="landing-page-rcl-header" [bg]="brandName" [expandable]="false">
	<a id="landing-page-rcl-header__go-to-brand" href="" aria-haspopup="true" (click)="goToBrandUrl($event)"
		tabindex="0">
		<img id="landing-page-rcl-header__go-to-brand__logo" class="{{ brandName }}-header-logo"
			src="assets/icons/{{ brandName }}-logo.svg"
			alt="{{ brandCorpAltText }} Home" />
	</a>
  <rcl-header-extra-option *ngIf="shouldDisplayMessageCenter">
   <main-nav-message-center ></main-nav-message-center>
  </rcl-header-extra-option>
	<rcl-menu-button id="landing-page-rcl-header__rcl-menu" [text]="bundle && bundle['user.menu.label.my.account']"
		[expanded]="showMenu" (onToggleNav)="toggleShowMenu()">
	</rcl-menu-button>

	<rcl-menu-button-dropdown id="landing-page-rcl-header__rcl-menu-dropdown" *ngIf="!isSafari">
		<app-user-menu [(showMenu)]="showMenu" [bundle]="bundle"></app-user-menu>
	</rcl-menu-button-dropdown>
</rcl-header>

<app-user-menu id="landing-page__user-menu" [(showMenu)]="showMenu" *ngIf="isSafari" [bundle]="bundle"></app-user-menu>

<rcl-main-content id="landing-page__rcl-main-content">
	<app-error-wrapper></app-error-wrapper>
	<ng-container *ngIf="alertMessages.length">
		<ng-container *ngFor="let alert of alertMessages">
			<rcg-notification-message
			[brand]="brandName"
			[notificationId]="alert.id"
			[type]="alert.type"
			[description]="alert.message"
			[dismissible]="alert.closable"
			[iconUrl]="alert.iconUrl"
			[customStyles]="alert.customStyles"
			[variant]="'inline'"
			></rcg-notification-message>
		</ng-container>
	</ng-container>

	<ng-container *ngIf="isAppEnabled">
		<section class="rcl-row app-banner-main-content" [class.mobile-content]="!screensize.isdesktop">
			<div class="rcl-col-md-12 rcl-col-sm-12 app-banner-rectangle">
				<div class="rcl-row">
					<div class="rcl-col-md-8 rcl-col-sm-12" [ngClass]="{'rcl-col-md-12': !screensize.isdesktop}">
						<h1 class="app-banner-header">
							{{ bundle && bundle['label.mobile.app.download.required'] }}
						</h1>

						<div class="rcl-row app-banner-store-buttons" [attr.tabindex]="0" *ngIf="!screensize.isdesktop">
							<div class="rcl-col-sm-12" *ngIf="device !== constants.DEVICE_TYPE.DESKTOP">
								<div *ngIf="isAppleDevice" class="rcl-col-sm-12">
									<a id="appstore" title="app-store" (click)="trackDeepLink(constants.OS_TYPE.IOS)"
										[href]="mobileAppLinks.unified" target="_blank">
										<img class="app-banner-download-img-width"
											src="assets/images/download-appstore.png"
											alt="App Store Button" />
									</a>
								</div>
								<div *ngIf="isAndroidDevice" class="rcl-col-sm-12">
									<a id="googleplay" title="google-play"
										(click)="trackDeepLink(constants.OS_TYPE.ANDROID)"
										[href]="mobileAppLinks.unified">
										<img class="app-banner-download-img-width"
											src="assets/images/download-googleplay.png"
											alt="Google Play Button" />
									</a>
								</div>
							</div>
							<div class="rcl-col-sm-12" *ngIf="device === constants.DEVICE_TYPE.DESKTOP">
								<a id="appstore" title="app-store" [href]="mobileAppLinks.ios" rel="noopener"
									(click)="trackDeepLink(constants.OS_TYPE.IOS)" target="_blank">
									<img class="app-banner-download-img-width"
										src="assets/images/download-appstore.png"
										alt="App Store">
								</a>
								<a id="googleplay" title="google-play" [href]="mobileAppLinks.android" rel="noopener"
									(click)="trackDeepLink(constants.OS_TYPE.ANDROID)" target="_blank">
									<img class="app-banner-download-img-width"
										src="assets/images/download-googleplay.png"
										alt="Google Play">
								</a>
							</div>
						</div>

						<ul class="app-banner-subheader rcl-col-md-12 rcl-col-sm-12">
							<li>{{ bundle && bundle['label.access.digital.boarding.pass'] }}</li>
							<li>{{ bundle && bundle['label.answer.health.check'] }}</li>
							<li>{{ bundle && bundle['label.embark.safely'] }}</li>
						</ul>
						<div class="rcl-col-row" *ngIf="screensize.isdesktop">
							<div class="app-banner-download-buttons">
								<a id="appstore" title="app-store" [href]="mobileAppLinks.ios" rel="noopener"
									(click)="trackDeepLink(constants.OS_TYPE.IOS)" target="_blank">
									<img class="app-banner-download-img-width app-banner-download-img-margin"
										src="assets/images/download-appstore.png"
										alt="App Store">
								</a>
								<a id="googleplay" title="google-play" [href]="mobileAppLinks.android" rel="noopener"
									(click)="trackDeepLink(constants.OS_TYPE.ANDROID)" target="_blank">
									<img class="app-banner-download-img-width"
										src="assets/images/download-googleplay.png"
										alt="Google Play">
								</a>
							</div>
						</div>
					</div>
					<div class="rcl-col-md-4 app-banner-static-img" *ngIf="screensize.isdesktop">
						<img class="app-banner-iphone-static-img" id="landing-page__rcl-main-content__static-mobile-app"
							src="assets/images/iphone-{{ brandName }}.png"
							alt="Mobile Boarding Pass">
					</div>
				</div>
			</div>
		</section>
	</ng-container>

	<section
		id="governance-content-banner" 
		*ngIf="checkInGuestSelectBanner" 
		class="rcl-row" 
		(click)="openGovernanceContentModal()"
    	[attr.tabindex]="checkInGuestSelectBanner ? 0 : -1"
		(keydown.enter)="openGovernanceContentModal()"
	>
		<div class="banner-container banner-container-{{ brandName }}">
			<div class="banner-alert-icon-container banner-alert-icon-container-{{ brandName }}">
				<div>
					<img class="alert-icon-banner" src="assets/icons/alert_icon.svg" alt="alert icon" />
				</div>
			</div>
			<div class="banner-content">
				<h2 class="rcl-h2 rcl-section-header-title banner-content-headline">{{ bundle && bundle['label.guestselect.safety.headline'] }}</h2>
				<p class="rcl-section-header-description banner-content-subcopy">{{ bundle && bundle['label.guestselect.safety.subcopy'] }}</p>
			</div>
			<div class="banner-right-arrow-container">
				<img class="right-arrow-banner" src="assets/icons/arrow-right.svg" alt="arrow right icon"/>
			</div>
		</div>
	</section>

	<ng-container id="landing-page__rcl-main-content__checked-in-guests"
		*ngIf="session && !session?.sailingClosed && guestsCompleted.length > 0">
		<rcl-section-header id="landing-page__rcl-main-content__checked-in-guests__header"
			[class.rcl-header-box]="isCubaItinerary">
			<rcl-section-title id="landing-page__rcl-main-content__checked-in-guests__header__title">
				{{ bundle && bundle['landing.page.title.checked.in.guests'] }}
			</rcl-section-title>
			<rcl-section-description id="landing-page__rcl-main-content__checked-in-guests__header__description">
				{{ bundle && bundle['landing.page.subtitle.checked.in.guests'] }}
			</rcl-section-description>
		</rcl-section-header>
	</ng-container>

	<ng-container id="landing-page__rcl-main-content__check-in-closed" *ngIf="session && session?.sailingClosed">
		<rcl-section-header id="landing-page__rcl-main-content__check-in-closed__header"
			[class.rcl-header-box]="isCubaItinerary">
			<rcl-section-title id="landing-page__rcl-main-content__check-in-closed__header__title">
				{{ bundle && bundle['error.check.in.closed.header'] }}
			</rcl-section-title>
			<rcl-section-description id="landing-page__rcl-main-content__check-in-closed__header__description"
				*ngIf="guestsCompleted.length > 0">
				{{ bundle && bundle['error.check.in.closed.subtitle'] }}
			</rcl-section-description>
		</rcl-section-header>
	</ng-container>

	<ng-container id="landing-page__rcl-main-content__guests-completed"
	*ngIf="isCubaItinerary && guestsCompleted.length">
		<div class="rcl-row">
			<div class="rcl-col-sm-12">
				 <rcg-notification-message
					[brand]="brandName"
					[variant]="'inline'"
					[type]="'info'"
					[notificationId]="'isCubaItinerary'"
					[description]="cubaItineraryMessage"
					[dismissible]="false"
					[iconUrl]="'assets/images/flag-cuba.png'"
					[customStyles]="customStyles"
				></rcg-notification-message> 
			</div>
		</div>
	</ng-container>

	<ng-container *ngFor="let bookingId of bookingIdsOfCompletedGuests">
		<div *ngIf="guestsCompleted.length > 0" class="rcl-row rcl-guest-checkin-completed-selector-title">
			<div class="rcl-col-sm-12">
				<h3 class="rcl-h3">
					{{ bundle && bundle['label.reservation.title'] }} - {{ bookingId }}
					<ng-container *ngIf="guestsService.isGuestLocked(guestsCompletedGrouped[bookingId][0])">
						<rcl-guest-action-status>{{ bundle && bundle['guest.booking.unavailable.label'] }}
						</rcl-guest-action-status>
						<rcl-tooltip [id]="'UnavailableTip1'" [buttonText]="bundle['button.okay']"
							[tooltipDescription]="bundle['tooltip.locked.booking']">
							<div>{{ bundle && bundle['tooltip.locked.booking'] }}</div>
						</rcl-tooltip>
					</ng-container>
				</h3>
			</div>
		</div>
		<app-guest-checkin-completed [guestsCompleted]="guestsCompletedGrouped[bookingId]" [session]="session"
			[bundle]="bundle">
		</app-guest-checkin-completed>
	</ng-container>

	<ng-container id="landing-page__rcl-main-content__select-guests"
		*ngIf="session && !session?.sailingClosed && guestsNotCompleted.length > 0">
		<div class="rcl-guests-not-completed">
			<rcl-section-header id="landing-page__rcl-main-content__select-guests__header">
				<rcl-section-title id="landing-page__rcl-main-content__select-guests__header__title">{{
					bundle && bundle['landing.page.title.select.guests']
					}}</rcl-section-title>
				<rcl-section-description id="landing-page__rcl-main-content__select-guests__header__description">{{
					bundle && bundle['landing.page.subtitle.select.guests']
					}}</rcl-section-description>
			</rcl-section-header>
		</div>

		<ng-container id="landing-page__rcl-main-content__select-guests__guest-completed"
		*ngIf="isCubaItinerary && !guestsCompleted.length">
			<div class="rcl-row">
				<div class="rcl-col-sm-12">
					<rcg-notification-message
						[brand]="brandName"
						[variant]="'inline'"
						[type]="'info'"
						[notificationId]="'isCubaItinerary'"
						[description]="cubaItineraryMessage"
						[dismissible]="false"
						[iconUrl]="'assets/images/flag-cuba.png'"
						[customStyles]="customStyles"
					></rcg-notification-message>
				</div>
			</div>
		</ng-container>

		<ng-container *ngFor="let bookingId of bookingIdsOfNotCompletedGuests">
			<div class="rcl-row rcl-guest-not-completed-selector-title">
				<div class="rcl-col-sm-12">
					<h3 class="rcl-h3">
						{{ bundle && bundle['label.reservation.title'] }} - {{ bookingId }}
						<ng-container *ngIf="guestsService.isGuestLocked(guestsNotCompletedGrouped[bookingId][0])">
							<rcl-guest-action-status>{{ bundle && bundle['guest.booking.unavailable.label'] }}
							</rcl-guest-action-status>
							<rcl-tooltip [id]="'UnavailableTip2'" [buttonText]="bundle['button.okay']"
								[tooltipDescription]="bundle['tooltip.locked.booking']">
								<div>{{ bundle && bundle['tooltip.locked.booking'] }}</div>
							</rcl-tooltip>
						</ng-container>
					</h3>
				</div>
			</div>
			<app-guest-selection-for-checkin [bundle]="bundle"
				[guestsNotCompleted]="guestsNotCompletedGrouped[bookingId]" (selectItem)="selectItem($event)"
				(onSubmit)="addAssociatedToReservation()" (associateGuests)="addAssociatedToReservation()">
			</app-guest-selection-for-checkin>
		</ng-container>

		<div>	
			<rcl-button-group>
				<div>
				    <rcg-primary-button
						type="button" 
						text="{{ bundle['button.continue'] }}" 
						(click)="goNext()" 
						(keydown.enter)="goNext()" 
						[disabled]="!canContinue()"
					></rcg-primary-button>
			    </div> 
			</rcl-button-group>
		</div>
	</ng-container>
</rcl-main-content>